import { c as _c } from "react/compiler-runtime";
import { BOOKINGS_API } from 'modules/calendar/bookings/api/bookings-api';
import { BookingDetailsInterface } from 'modules/calendar/bookings/types/booking-details-interface';
import { useFetch } from 'shared/hooks/use-fetch';
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types';
import { useOnceTrue } from 'shared/hooks/use-once-true';
import { useControlledSwr } from 'shared/hooks/use-controlled-swr';
import { RequestModuleEnum } from 'shared/enums/request-module-enum';
interface UseBookingDetailsProps {
  bookingId: number | undefined;
  opened: boolean;
}
export const useBookingDetails = t0 => {
  const $ = _c(7);
  const {
    bookingId,
    opened
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      method: RequestMethodsEnum.get
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    fetcher
  } = useFetch(t1);
  const allowed = useOnceTrue(opened);
  let t2;
  if ($[1] !== allowed || $[2] !== bookingId) {
    t2 = () => {
      if (!allowed || !bookingId) {
        return;
      }
      return [`${BOOKINGS_API}/${bookingId}`, RequestModuleEnum.Contacts, RequestModuleEnum.CalendarBookings];
    };
    $[1] = allowed;
    $[2] = bookingId;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const {
    data,
    mutate
  } = useControlledSwr(t2, fetcher);
  let t3;
  if ($[4] !== data || $[5] !== mutate) {
    t3 = {
      bookingDetails: data,
      bookingDetailsMutate: mutate
    };
    $[4] = data;
    $[5] = mutate;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
};